import {
  AddressFunctionItem,
  AddressFunctionResponse,
} from '@/types/service-response'

export class AddressFunction {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: AddressFunctionResponse): Array<AddressFunction> {
    let result: Array<AddressFunction> = []
    if (responseData) {
      result = responseData.map((item: AddressFunctionItem ) => {
        return new AddressFunction(
          item.ID,
          item.Bezeichnung,
        )
      })
    }
    return result
  }
}
